const reimburse = {
  plCode: '請輸入編碼',
  plName: '請輸入名稱',
  plDesc: '請輸入描述',
  disableTip: '確定禁用該類目嗎',
  disableConfirm: '禁用確認',
  disableConfirmContent: '確定禁用類目',
  disableSuccess: '禁用成功',
  disableSuccessDesc: '已禁用',
  disableFailed: '禁用失敗',
  disableFailedHasSubs: '該類目存在子類目，無法禁用',
  addSuccessDesc: '添加成功',
  updateSuccessDesc: '更新成功',
  addFailed: '添加失敗',
  codeDuplicate: '編碼重複',
  applicationTypeLabel: '申請類型',
  approveTypeLabel: '審批方式',
  stepCount: '步驟數',
  reimbursement: '報銷申請',
  dailySupplies: '日用品/物料申請',
  materialOverIssue: '超領領料申請',
  addMaterialOverIssue: '新增超領申請',
  materialOverIssueList: '超領申請列表',
  inOrder: '按順序審批',
  any: '任一步驟同意',
  last: '最終步驟同意',
  templateConfig: '模板配置',
  approvalSteps: '審批步驟',
  step: '步驟',
  addStep: '添加步驟',
  specificOrgAnyone: '指定組織任何人',
  applicantOrgAnyone: '申請人組織任何人',
  specificUsers: '選定多個人',
  plSelectOrg: '請輸入組織ID',
  plOrgId: '組織ID',
  plSelectUsers: '請選擇用戶',
  number: '單號',
  title: '標題',
  status: '狀態',
  statusAll: '全部',
  statusDraft: '草稿',
  statusPending: '待審批',
  statusApproved: '已審批',
  statusRejected: '已拒絕',
  statusReturned: '已退回',
  applicationList: '申請列表',
  addApplication: '新增申請',
  plTitle: '請輸入標題',
  plContent: '請輸入內容',
  plPurpose: '請輸入用途',
  plRemark: '請輸入備註',
  content: '內容',
  purpose: '用途',
  remark: '備註',
  items: '物料明細',
  itemList: '申請項目列表',
  count: '數量',
  selectProducts: '按料號添加',
  plSelectProducts: '請選擇物料',
  submit: '提交',
  reSubmit: '重新提交',
  submitSuccess: '提交成功',
  submitFailed: '提交失敗',
  amount: '金額',
  orderAmount: '應領數量',
  productId: '物料ID',
  requirementItemId: '需求清單項',
  overCount: '超領數量',
  reasonType: '超領原因',
  reasonMistake: '失誤',
  reasonWaste: '浪費',
  reasonOther: '其他',
  reason: '詳細說明',
  picked: '已生成出庫單',
  pickedYes: '是',
  pickedNo: '否',
  expenseDate: '費用日期',
  invoiceCount: '發票數量',
  plAmount: '請輸入金額',
  plInvoiceCount: '請輸入發票數量',
  plExpenseDate: '請選擇費用日期',
  atLeastOne: '至少保留一項',
  submitConfirm: '確定提交報銷單嗎？',
  submitOverIssueConfirm: '確定提交超領申請嗎？',
  addDailyItem: '無料號添加',
  approver: '審批人',
  actualApprover: '實際審批人',
  approveTime: '審批時間',
  approveOrg: '審批組織',
  applicant: '申請人',
  submitTime: '提交時間',
  completeTime: '完成時間',
  stepNo: '步驟',
  pass: '通過',
  reject: '拒絕',
  return: '退回',
  passSuccess: '已通過',
  rejectSuccess: '已拒絕',
  returnSuccess: '已退回',
  passFailed: '通過失敗',
  rejectFailed: '拒絕失敗',
  returnFailed: '退回失敗',
  confirmPass: '確定通過該審批嗎？',
  confirmReject: '確定拒絕該審批嗎？',
  confirmReturn: '確定退回該審批嗎？',
  approveRemark: '審批備註',
  plApproveRemark: '請輸入審批備註',
  timeout: '超時時間',
  approvalTimeLimit: '審批時限',
  enableConfirm: '啟用確認',
  disableCascadeTip: '禁用該類目會同步禁用該類目下的所有類目',
  enableCascadeTip: '啟用該類目會同步啟用該類目下的所有類目',
};

export default reimburse;
